<div class="apple-card">
  <div class="apple-card-header">
    <div class="apple-card-icon">
      <mat-icon>history</mat-icon>
    </div>
    <div class="apple-card-title-section">
      <h3>Coin-Verwendungshistorie</h3>
      <p>Transaktionsübersicht für diese Bestellung</p>
    </div>
  </div>

  <div class="apple-card-content">
    <!-- Loading State -->
    <div *ngIf="loading" class="loading-state">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Lade Historie...</span>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="error-state">
      <mat-icon>error</mat-icon>
      <p>{{ error }}</p>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading && !error && orderHistory.length === 0" class="empty-state">
      <mat-icon>info</mat-icon>
      <p>Keine Historie verfügbar</p>
    </div>

    <!-- Data Table -->
    <div *ngIf="!loading && !error && orderHistory.length > 0" class="history-table-container">
      <table mat-table [dataSource]="orderHistory" class="apple-table">
        
        <!-- Invoice Number Column -->
        <ng-container matColumnDef="invoiceNo">
          <th mat-header-cell *matHeaderCellDef>Rechnungsnummer</th>
          <td mat-cell *matCellDef="let item">{{ item.invoiceNo }}</td>
        </ng-container>

        <!-- State Text Column -->
        <ng-container matColumnDef="stateText">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let item">
            <span class="status-badge">{{ item.stateText }}</span>
          </td>
        </ng-container>

        <!-- Coin Amount Column -->
        <ng-container matColumnDef="coinAmount">
          <th mat-header-cell *matHeaderCellDef>Coins</th>
          <td mat-cell *matCellDef="let item">
            <span class="coin-badge" [class.positive]="item.coinAmount > 0" [class.negative]="item.coinAmount < 0">
              {{ item.coinAmount > 0 ? '+' : '' }}{{ item.coinAmount }}
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
</div>
